import React from 'react';
import { MissionProvider } from './context/MissionContext';
import { UIProvider } from './context/UIContext';
import { CesiumProvider } from './context/CesiumContext';
import { useCesiumMap } from './hooks/useCesiumMap';
import MDCockpitInner from './MDCockpitInner';

// Instantiate useCesiumMap once here so its refs survive re-renders and are
// accessible to any child via useCesium()
const MDCockpitWithCesium: React.FC = () => {
  const cesiumApi = useCesiumMap();
  return (
    <CesiumProvider api={cesiumApi}>
      <MDCockpitInner cesium={cesiumApi} />
    </CesiumProvider>
  );
};

const MDCockpit: React.FC = () => (
  <MissionProvider>
    <UIProvider>
      <MDCockpitWithCesium />
    </UIProvider>
  </MissionProvider>
);

export default MDCockpit;
